// ABOUTME: Grid of all pack squares shown as bingo balls for host-pick mode.
// ABOUTME: Orange balls are uncalled (clickable to call); teal balls are already called.
import Typography from '@mui/material/Typography'
import { BingoBallGrid, BingoBall } from '../theme'
import type { GameSquareDto } from '../api/generated'
import type { CalledGameSquare } from '../api/generated'

interface Props {
  packSquares: GameSquareDto[]
  calledSquares: CalledGameSquare[]
  onCallSquare?: (squareId: string) => void
  optimisticallyCalledIds?: Set<string>
}

export function HostPickGrid({ packSquares, calledSquares, onCallSquare, optimisticallyCalledIds }: Props) {
  const calledIds = new Set(
    calledSquares.map((cs) => (cs as Record<string, unknown>)['gameSquareId'] as string)
  )

  return (
    <BingoBallGrid>
      {packSquares.map((sq) => {
        const isCalled = calledIds.has(sq.id) || (optimisticallyCalledIds?.has(sq.id) ?? false)
        return (
          <BingoBall
            key={sq.id}
            called={isCalled}
            aria-pressed={isCalled}
            onClick={() => { if (!isCalled) onCallSquare?.(sq.id) }}
          >
            <Typography variant="caption" lineHeight={1.2}>{sq.title}</Typography>
          </BingoBall>
        )
      })}
    </BingoBallGrid>
  )
}
